import React, { useContext, useEffect } from 'react';
import { Form, Input, Button } from "antd"
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context/AppContext';

export const Login = () => {
    const placeHolderLink = "https://www.sukiadvantage.com/help-center"
    const context = useContext(AppContext);
    const [loading, setLoading] = React.useState(false)
    const { onLogin } = context;
    const [form] = Form.useForm();
    const [errorMessage, setErrorMessage] = React.useState<string | null>(null);

    useEffect(() => {

    }, []);

    const backgroundImage = require('../assets/images/background.png');
    const sukiLogo = require('../assets/images/suki-logo-white.png');

    const backgroundStyle = {
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        width: '100%',
        overflowY: 'hidden' as 'hidden',
    };

    const loginPanelStyle = {
        boxShadow: '-10px 12px 28px rgba(53, 54, 119, 0.37)',
        width: '450px',
    };

    const navigate = useNavigate();

    const onFinish = async (values: any) => {
        const payload = {
            email: values.email,
            password: values.confirmPassword,
        }
    
        try {
            setLoading(true);
    
            const response = await onLogin(payload);
    
            if (response) {
                const { is_password_set: isPasswordSet, user_role: userRole } = response;
    
                if (isPasswordSet === "false") {
                    navigate('/create-password');
                } else {
                    navigate(userRole === 'partner' ? '/partners/transactions' : '/operations/transactions');
                }
            } else {
                setErrorMessage('Invalid login');    
            }
        } catch (e) {
            console.error(e.response?.data || e.message);
            setErrorMessage('Invalid login');
        } finally {
            setLoading(false);
        }
    };    

    const onValuesChange = () => {
        setErrorMessage(null);
    };

    return (
        <div style={backgroundStyle}>
            <div className="flex flex-col justify-center items-center h-screen">
                <img src={sukiLogo} className="h-[130px]" alt="Suki Logo" />
                <div className="bg-neutralWhite-25 rounded-2xl login-panel p-11 mt-8" style={loginPanelStyle}>
                    <Form form={form} onFinish={onFinish} onValuesChange={onValuesChange}>
                        <h1 className="text-3xl text-neutralBlack mb-2 font-poppinsSemiBold">
                            Login to your account
                        </h1>
                        <p className="text-body3 font-normal text-neutralBlack-75 mb-4 font-poppinsRegular">
                            Enter your credentials to access your account
                        </p>

                        <label className="text-sm text-neutralGray font-medium font-poppinsRegular required">
                            Email Address
                        </label>
                        <Form.Item
                            name="email"
                            className="w-full"
                            rules={[{ required: true, message: 'Please input a valid email', type: 'email' }]}
                        >
                            <Input
                                className="h-12"
                                onChange={onValuesChange}
                            />
                        </Form.Item>

                        <label className="text-sm text-neutralGray font-medium font-poppinsRegular required">
                            Password
                        </label>
                        <Form.Item name="confirmPassword" className="w-full" rules={[{ required: true, message: 'Please input your password' }]}>
                            <Input.Password
                                className="h-12"
                                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                                onChange={onValuesChange}
                            />
                        </Form.Item>

                        <Form.Item>
                            <Form.ErrorList className="text-red-500 mb-2 -mt-2 text-body3" errors={[errorMessage]} />

                            <Button
                                htmlType="submit"
                                className="w-full text-neutralWhite bg-primary text-base font-poppinsMedium leading-6 border-primary hover:bg-primary-hovered hover:text-neutral-50 active:border-primary-border active:bg-primary-clicked py-2 mt-1 h-12"
                                loading={loading}
                                disabled={loading}
                            >
                                {loading ? 'Processing' : 'Proceed'}
                            </Button>
                        </Form.Item>

                        <p className='text-base font-poppinsRegular text-center whitespace-nowrap'>
                            Don't have an account? <a href={placeHolderLink} className="underline text-primary text-base font-semibold font-poppinsSemiBold">Contact Administrator</a>
                        </p>

                    </Form>
                </div>
            </div>
        </div>
    );
};
